import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { X } from 'lucide-react';

const COOKIE_CONSENT_KEY = 'socrates_cookie_consent';

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      // Small delay so it doesn't flash on initial load
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    setVisible(false);
  };

  const handleDismiss = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'dismissed');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-in slide-in-from-bottom duration-300">
      <div className="container mx-auto max-w-2xl">
        <div className="bg-stone-800 border border-stone-700 rounded-lg shadow-lg p-4 flex flex-col sm:flex-row items-start sm:items-center gap-3">
          <p className="text-stone-300 text-sm flex-1">
            We use cookies for authentication and analytics to improve your experience.
            See our{' '}
            <Link to="/privacy" className="text-white underline hover:text-stone-200">
              Privacy Policy
            </Link>{' '}
            for details.
          </p>
          <div className="flex items-center gap-2 shrink-0">
            <Button
              size="sm"
              onClick={handleAccept}
              className="bg-stone-600 hover:bg-stone-500 text-white"
            >
              Accept
            </Button>
            <button
              onClick={handleDismiss}
              className="text-stone-500 hover:text-stone-300 p-1"
              aria-label="Dismiss"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
